const isBrowser = typeof window !== 'undefined'

export const PAGE_FORM_COMPLETION_EVENT = 'harbor:page-form-complete'

export const normalizePageUnlockPath = (value = '') => {
  const rawValue = typeof value === 'string' && value.trim() ? value.trim() : '/'
  const withoutOrigin = rawValue.replace(/^https?:\/\/[^/]+/i, '')
  const [pathname] = withoutOrigin.split(/[?#]/)
  const normalizedPath = pathname.replace(/\/+$/, '') || '/'
  return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`
}

const buildPageFormUnlockStorageKey = (pathname = '') =>
  `page-form-complete:${normalizePageUnlockPath(pathname)}`

export const hasPageFormCompleted = (pathname = '') => {
  if (!isBrowser) return false

  try {
    return window.sessionStorage.getItem(
      buildPageFormUnlockStorageKey(pathname || window.location.pathname)
    ) === 'true'
  } catch {
    return false
  }
}

export const markPageFormCompleted = (pathname = '') => {
  if (!isBrowser) return

  const normalizedPath = normalizePageUnlockPath(pathname || window.location.pathname)

  try {
    window.sessionStorage.setItem(
      buildPageFormUnlockStorageKey(normalizedPath),
      'true'
    )
  } catch {
    /* no-op */
  }

  window.dispatchEvent(
    new CustomEvent(PAGE_FORM_COMPLETION_EVENT, {
      detail: { pathname: normalizedPath },
    })
  )
}
